import {
    ACTION_GET_CHAPTER_LIST_FAILED,
    ACTION_GET_CHAPTER_LIST_STARTED,
    ACTION_GET_CHAPTER_LIST_SUCCEEDED
} from "../actions/actionTypes";

export default function (state = {chaptersList: [], chapterFailed: false}, action) {
    switch (action.type) {
        case ACTION_GET_CHAPTER_LIST_SUCCEEDED:
            return {...state, chaptersList: action.chapterList, chapterFailed: false};
        case ACTION_GET_CHAPTER_LIST_STARTED:
            return {...state, chaptersList: [], chapterFailed: false};
        case ACTION_GET_CHAPTER_LIST_FAILED:
            return {...state, chapterFailed: true};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/chapter_list.js